import { render } from "./CascoLetter.vue?vue&type=template&id=1578dad6&scoped=true"
import script from "./CascoLetter.vue?vue&type=script&lang=js"
export * from "./CascoLetter.vue?vue&type=script&lang=js"

import "./CascoLetter.vue?vue&type=style&index=0&id=1578dad6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1578dad6"]])

export default __exports__